(function () {
  var header = document.getElementById('site-header');
  if (!header) return;

  // TOPの透過ヘッダー: スクロールで白背景・黒文字に遷移
  if (header.dataset.overlay === 'true') {
    var update = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // SPドロワー: 開いている間は背面のスクロールを止める。ESC・リンク遷移で閉じる
  var drawer = document.getElementById('site-drawer');
  if (drawer) {
    drawer.addEventListener('toggle', function () {
      document.documentElement.classList.toggle('site-drawer-open', drawer.open);
      header.classList.toggle('is-drawer-open', drawer.open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.open) drawer.removeAttribute('open');
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { drawer.removeAttribute('open'); });
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (e) {
      if (e.matches) drawer.removeAttribute('open');
    });
  }
})();
